IrrigationDetailsBase = App.loadClass 'grower::Angular/IrrigationDetailsBase'


# Handle the irrigation details step
class exports.IrrigationDetailsController extends IrrigationDetailsBase

    constructor: (@scope, @transitions, @validation, @service, @ngModal) ->
        super(@scope, @transitions)

        @scope.copy = @copy
        @scope.field_data = @validation.getFieldData()
        @scope.validate = @validate
        @scope.validationService = @validation
        @scope.validationService.setStepScope(@scope)
        @scope.validation = @validation.validate
        @showOnMap(@scope.field_data.zones.irrigation)

        @alwaysRequiredInputs = [
            'irrigation_method_id'
            'water_source_id'
            'irrigation_water_conservation'
            'tail_water_recovery'
            'use_pumps'
        ]

        # initialize details
        if @scope.field_data.zones.irrigation.details?
            @scope.details = @scope.field_data.zones.irrigation.details
        else if @scope.field_data.zones.irrigation.copied?
            @scope.details = @scope.field_data.zones.irrigation.copied
        else
            @scope.details = {
                # set the input default
                irrigation_method_id: null,
                irrigation_water_conservation: null,
                tail_water_recovery: null,
                use_pumps: null,
                energy_source: null,
                pump_pressure: null,
                pumping_depth: null,
                water_source_id: null,
                secondary_irrigation: false,
                secondary_use_pumps: null,
                secondary_energy_source: null,
                secondary_pump_pressure: null,
                secondary_pumping_depth: null,
            }

        @service.getMethods().then (response) =>
            @scope.irrigation_methods = response.data.data

        @service.getSources().then (response) =>
            @scope.energy_sources = response.data
            @setLoadedEnergySource()
            # rerun validation after loading energy sources since we require an energy source
            @scope.validationService.validate()

        # load water sources (this could probably be a resolve)
        @service.getWaterSources().then (response) =>
            @scope.water_sources = response.data
            @scope.secondaryIrrigationWaterSourceId = @scope.water_sources.find((source) => return source.name is "Both Surface Water and Deep Aquifer Groundwater").id
            @scope.validationService.validate()

        # remove map layers when we leave the step
        @scope.$on '$destroy', () =>
            for area in @scope.field_data.zones.irrigation.zones
                App.map.removeLayer area.visible

        @validation.setBackButtonDisable(@scope.field_data, false)

        # call validation to enable the button if all inputs are defaulted to valid values
        @scope.validationService.validate()

    validate: (ending) =>
        return false if not @scope.details? or not @scope.water_sources

        # fail validation if one of the always required inputs does not have a selection
        return false if false in (detail? for key, detail of @scope.details when key in @alwaysRequiredInputs)

        # fail validation if we are using pumps but have not filled out the pump related inputs
        return false if @scope.details.use_pumps is true and (not @scope.details.energy_source? or not @scope.details.pump_pressure? or not @scope.details.pumping_depth?)

        # fail validation if we are using secondary irrigation pumps but have not filled out the seconddary irrigation pump related inputs
        return false if @scope.details?.secondary_use_pumps is true and (not @scope.details.secondary_energy_source? or not @scope.details.secondary_pump_pressure? or not @scope.details.secondary_pumping_depth?)

        # require secondary use pumps if we have the water source that requires  it
        return false if @scope.details?.water_source_id is @scope.water_sources.find((source) =>
            return source.name is 'Both Surface Water and Deep Aquifer Groundwater'
        ).id and not @scope.details?.secondary_use_pumps?

        # if we pass validation, set the values on the management zone and return true
        @scope.field_data.zones.irrigation.details = @scope.details

        return true

    showOnMap: (zones) =>
        for area in zones.zones
            geojson = area.visible.toGeoJSON()

            area.visible.clearLayers()

            # set layer styles
            L.geoJson(geojson).eachLayer (l) =>
                l.setStyle({ weight: 2, color: area.color, fillOpacity: 0.6 })
                area.visible.addLayer(l)
                @validation.pgis.added_layers.push l

            # add to map
            area.visible.addTo App.map

    copy: () =>
        if @validate()
            @ngModal.openCopyIrrigationDetailsDialog(parseInt(@scope.field_data.id), parseInt(@scope.field_data.year), @scope.details)
